import React, { useEffect, useState } from 'react';
import { Route, useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { getAPI } from 'store/apiReducer';
import {
    Container,
    Modale,
    ModaleTitre,
    ModaleContent,
    ModaleFooter,
    Bouton,
} from '@design-system-etat/dsfr-react';
import * as PropTypes from 'prop-types';
import { getPath } from '../utils/router';
import Routes from './routes';
import EspaceDetenteurs from './espace-detenteurs';
import FooterComponent from '../components/footer/FooterComponent';
import HeaderComponent from '../components/header/HeaderComponent';
import Compte from './compte';
import usagerClientReducer from '../store/usagerReducer';
import {
    API_GET_CORRIGER_COMPTE_INCOHERENT,
    API_GET_FEATURE_FLIPPING,
    API_GET_NOMBRE_NOTIFICATIONS,
    API_GET_PROFIL,
    CONTEXT_GET_CORRIGER_COMPTE_INCOHERENT,
    CONTEXT_GET_FEATURE_FLIPPING,
    CONTEXT_GET_NOMBRE_NOTIFICATIONS,
    CONTEXT_GET_PROFIL,
} from '../constants/apiUrls.constants';
import Alerts from '../components/Alertes/Alertes';
import ContacterPrefecture from './espace-detenteurs/nous-contacter';
import ContacterPrefectureNonConnecte from './nous-contacter';
import MentionsLegales from './mentions-legales';
import DonneesPersonnelles from './donnees-personnelles';
import Deconnexion from './deconnexion';
import Accessibilite from './accessibilite';

const IndexPage = ({ getApi, isLoadingProfil, dataProfil }) => {
    // Redirection provisoire car la page d'accueil n'a pas encore été réalisée.
    if (useLocation().pathname === getPath(Routes.subroutes.espaceDetenteurs)) {
        useHistory().push(getPath(Routes.subroutes.espaceDetenteurs.subroutes.ratelier));
    }

    const isConnecte = useLocation().pathname.includes(getPath(Routes.subroutes.espaceDetenteurs));
    const [displayModaleMiseAJourCompte, setDisplayModaleMiseAJourCompte] = useState(false);
    const { roles, numeroSia } = dataProfil || {};

    useEffect(() => {
        if (isConnecte) {
            getApi(usagerClientReducer, API_GET_PROFIL, CONTEXT_GET_PROFIL);
            getApi(
                usagerClientReducer,
                API_GET_NOMBRE_NOTIFICATIONS,
                CONTEXT_GET_NOMBRE_NOTIFICATIONS,
            );
        }
    }, [isConnecte]);

    useEffect(() => {
        if (!isLoadingProfil && dataProfil && roles.length === 0) {
            getApi(
                usagerClientReducer,
                API_GET_CORRIGER_COMPTE_INCOHERENT + numeroSia,
                CONTEXT_GET_CORRIGER_COMPTE_INCOHERENT,
            );
            setDisplayModaleMiseAJourCompte(true);
        }
    }, [dataProfil]);

    useEffect(() => {
        getApi(usagerClientReducer, API_GET_FEATURE_FLIPPING, CONTEXT_GET_FEATURE_FLIPPING);
    }, []);

    const fermerModaleMiseAJourCompte = () => {
        setDisplayModaleMiseAJourCompte(false);
        window.location.href = process.env.REACT_APP_KEYCLOAK_LOGOUT_URI;
    };

    return (
        <div>
            <HeaderComponent isConnecte={isConnecte} />
            {!displayModaleMiseAJourCompte ? (
                <>
                    <Alerts />
                    <div className="position-relative">
                        <Container>
                            <Route
                                path={getPath(Routes.subroutes.espaceDetenteurs)}
                                render={(subProps) => <EspaceDetenteurs {...subProps} />}
                            />
                            <Route
                                path={getPath(Routes.subroutes.nousContacterPublique)}
                                render={(subProps) => (
                                    <ContacterPrefectureNonConnecte {...subProps} />
                                )}
                            />
                            <Route
                                path={getPath(Routes.subroutes.mentionsLegales)}
                                render={(subProps) => <MentionsLegales {...subProps} />}
                            />
                            <Route
                                path={getPath(Routes.subroutes.donneesPersonnelles)}
                                render={(subProps) => <DonneesPersonnelles {...subProps} />}
                            />
                            <Route
                                path={getPath(Routes.subroutes.accessibilite)}
                                render={(subProps) => <Accessibilite {...subProps} />}
                            />
                            <Route
                                path={getPath(Routes.subroutes.deconnexion)}
                                render={(subProps) => <Deconnexion {...subProps} />}
                            />
                            <Route
                                path={getPath(Routes.subroutes.nousContacterPrivee)}
                                render={(subProps) => (
                                    <ContacterPrefecture {...subProps} roles={roles} />
                                )}
                            />
                        </Container>
                        <Route
                            path={getPath(Routes.subroutes.compte)}
                            render={(subProps) => <Compte {...subProps} />}
                        />
                    </div>
                </>
            ) : (
                <Modale id="miseAJour" taille="lg" closeCallback={fermerModaleMiseAJourCompte}>
                    <ModaleTitre idModale="miseAJour">Mise à jour</ModaleTitre>
                    <ModaleContent>
                        <p>
                            Vous allez être déconnecté de votre compte en raison d&apos;une mise à
                            jour du SIA. Merci de vous reconnecter
                        </p>
                    </ModaleContent>
                    <ModaleFooter>
                        <div className="fr-grid-row">
                            <div className="fr-col-12 btn-group-align-right">
                                <Bouton
                                    name="Confirmer"
                                    label="Confirmer"
                                    niveau="primaire"
                                    onClick={fermerModaleMiseAJourCompte}
                                />
                            </div>
                        </div>
                    </ModaleFooter>
                </Modale>
            )}
            <FooterComponent isConnecte={isConnecte} />
        </div>
    );
};

IndexPage.propTypes = {
    getApi: PropTypes.func.isRequired,
    isLoadingProfil: PropTypes.bool,
    dataProfil: PropTypes.shape({
        numeroSia: PropTypes.string,
        roles: PropTypes.array,
    }),
};

export default connect(
    (state) => {
        const { isLoading: isLoadingProfil, data: dataProfil } = state.profil.usager;

        return {
            isLoadingProfil,
            dataProfil,
        };
    },
    { getApi: getAPI },
)(IndexPage);
